import React, { memo, useState, useCallback } from 'react';
import { DatePicker, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import { formatDate, parseDateWithFormat } from 'lib/dates';

import styles from './styles';

const useStyles = createUseStyles(styles, 'DatePickerCell');

const DatePickerCell = memo((params) => {
    const { language, locale } = useWeb5Context();
    const [date, setDate] = useState(parseDateWithFormat(params.value, locale, 'P') || '');
    const classes = useStyles();

    const field = params.colDef.field;
    const { onChange, ...inputParams } = params.inputParams;
    const lineOverrides = params.data?._lineSmartFieldOverrides?.[field];
    if (lineOverrides?.readOnly || lineOverrides?.hidden) {
        inputParams.isReadOnly = true;
    }
    if (lineOverrides?.mandatory) {
        inputParams.isMandatory = true;
    }
    const handleOnChange = useCallback(
        (value) => {
            const id = params.data.id || params.data.Id || params.data.ID || '';
            onChange({ rowIndex: params.node.rowIndex, id, field, value });
            setDate(value);
        },
        [onChange, field, params],
    );

    const format = useCallback(
        (value) => {
            return formatDate(value, locale, 'P');
        },
        [locale],
    );

    if (!params.inputParams) return null;

    if (params.CustomCell) {
        const CustomCell = params.CustomCell;
        return <CustomCell value={date} onChange={handleOnChange}></CustomCell>;
    }

    return (
        <div className={['w5-cell', classes.editableCell].join(' ')}>
            <DatePicker
                value={date}
                onChange={handleOnChange}
                lang={language}
                formatDate={format}
                isFullWidth
                {...inputParams}
            />
        </div>
    );
});

export default DatePickerCell;
